<template>
  <div class="web-browser">
    <div class="toolbar">
      <i class="fas fa-circle"></i>
      <i class="fas fa-circle"></i>
      <i class="fas fa-circle"></i>
      <div class="search-bar"></div>
      <i class="fas fa-circle"></i>
    </div>
    <img
      alt=""
      class="img-fluid"
      :src="img"
    />
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.web-browser {
  border: 2px solid var(--f-g2);
  border-radius: 4px;
  box-sizing: border-box;
  height: auto;
  margin: 1.5rem auto;
  max-width: 100%;
  position: relative;
  text-align: center;
  max-width: 888px;

  .toolbar {
    background: var(--f-g1);
    border-bottom: 2px solid var(--f-g2);
    color: var(--f-g3);
    padding: .25rem .5rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select :none;
    user-select: none;

    i {
      margin: .25rem .125rem;
    }

    .search-bar {
      background-color: var(--f-g3);
      border-radius: .2rem;
      display: inline-block;
      height: 1rem;
      width: 100%;
      margin: 0 .5rem;
      vertical-align: middle;
    }
  }

  .img-fluid {
    padding: 4px 2px 2px;
  }
}
</style>
